import type { Dispatch } from 'react';
import { IdentitySection } from '../tenant-sections/IdentitySection';
import type { WizardAction, WizardDraft } from './types';

/**
 * Paso 1 del wizard = la sección Identidad montada en modo wizard.
 * El paso solo traduce draft ⇄ props de la sección; la lógica vive en la sección.
 */
export function Step1Identity({
  draft,
  dispatch,
}: {
  draft: WizardDraft;
  dispatch: Dispatch<WizardAction>;
}) {
  return (
    <IdentitySection
      mode="wizard"
      testId="wizard-step-1"
      tenantId={draft?.tenantId ?? ''}
      value={{ tenantId: draft?.tenantId, name: draft?.name }}
      onSaved={(patch) => {
        const p = patch as { tenantId: string; name: string };
        dispatch({
          type: 'set-tenant',
          tenantId: p.tenantId,
          name: p.name,
          botMode: 'informational',
        });
      }}
    />
  );
}
